/**
 * @flow
 * @relayHash 21f166b3243024c542d8fa4099d281e7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventCategorySearchPage_viewer$ref = any;
export type EventCategorySearchPageRefetchQueryVariables = {|
  eventId: string,
  language?: ?string,
  startnumber: string,
  categoryId: string,
  count: number,
  cursor?: ?string,
  secondFactor?: ?string,
  individualPart?: ?string,
  noStartnumber?: ?boolean,
  fetchCategory?: ?boolean,
  fetchAllPhotos?: ?boolean,
  minTime?: ?any,
  maxTime?: ?any,
|};
export type EventCategorySearchPageRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventCategorySearchPage_viewer$ref
  |}
|};
export type EventCategorySearchPageRefetchQuery = {|
  variables: EventCategorySearchPageRefetchQueryVariables,
  response: EventCategorySearchPageRefetchQueryResponse,
|};
*/


/*
query EventCategorySearchPageRefetchQuery(
  $eventId: ID!
  $language: String
  $startnumber: ID!
  $categoryId: ID!
  $count: Int!
  $cursor: String
  $secondFactor: String
  $individualPart: String
  $noStartnumber: Boolean
  $fetchCategory: Boolean
  $fetchAllPhotos: Boolean
  $minTime: NaiveDatetime
  $maxTime: NaiveDatetime
) {
  viewer {
    ...EventCategorySearchPage_viewer
    id
  }
}

fragment EventCategorySearchPage_viewer on Viewer {
  event(id: $eventId, language: $language) {
    id
    sgId
    gps
    hostResultUrl
    media @include(if: $fetchAllPhotos) {
      mediaInfo {
        shotDateMax
        shotDateMin
      }
      ...MediaCollectionList_mediaCollectionMedia_2HnSXF
    }
    mediaCollection(id: $categoryId) @include(if: $fetchCategory) {
      id
      media {
        mediaInfo {
          shotDateMax
          shotDateMin
        }
        ...MediaCollectionList_mediaCollectionMedia_2HnSXF
      }
    }
    participant(startnumber: $startnumber, secondFactor: $secondFactor) @skip(if: $noStartnumber) {
      media {
        mediaInfo {
          count
        }
      }
      startnumber
      id
    }
    searchAllPhotos
    secondFactorType {
      type
      id
    }
    searchByFace
    searchDual
    smartSearch
    state
    ...EventOnlineView_onlineEvent
    ...MediaCollectionList_offer
  }
}

fragment EventInfoCard_eventInfo on Event {
  id
  sgId
  beginsAt
  banner
  hostHomepageName
  hostHomepageUrl
  location
  name
  predecessorEvent {
    name
    id
  }
}

fragment EventOnlineView_onlineEvent on Event {
  id
  sgId
  hostResultUrl
  name
  ...EventInfoCard_eventInfo
  ...StartNumberSearch_info
  ...ExtendedSearch_event
}

fragment ExtendedSearchCategorySearchTab_categories on Event {
  mediaCollections {
    id
    name
  }
  searchAllPhotos
}

fragment ExtendedSearchDualSearchTab_event on Event {
  id
  sgId
  searchByFace
  ...StartNumberSearch_info
}

fragment ExtendedSearch_event on Event {
  id
  sgId
  searchByFace
  ...ExtendedSearchCategorySearchTab_categories
  ...ExtendedSearchDualSearchTab_event
}

fragment MediaCollectionList_mediaCollectionMedia_2HnSXF on ExtendedMediaConnection {
  mediaList(first: $count, after: $cursor, afterShotDate: $minTime, beforeShotDate: $maxTime) {
    edges {
      node {
        id
        __typename
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    ...MediaList_media
  }
}

fragment MediaCollectionList_offer on Event {
  ...MediaList_offer
}

fragment MediaListItem_item on Media {
  id
  sgId
  name
  shotDate
  variants {
    name
    url
    id
  }
}

fragment MediaList_media on MediaConnection {
  edges {
    node {
      id
      sgId
      shotDate
      variants {
        name
        url
        id
      }
      ...MediaListItem_item
    }
  }
}

fragment MediaList_offer on Event {
  products {
    id
    mediaCollection {
      name
      id
    }
    price
    type
  }
  voucherCampaign {
    banner
    name
    shortText
    id
  }
}

fragment StartNumberSearch_info on Event {
  id
  gps
  searchByFace
  searchDual
  secondFactorEventSalt(individualPart: $individualPart)
  secondFactorType {
    type
    id
  }
  sgId
  hostResultUrl
  warnText
  faceWebcamOnly
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "eventId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "language",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "startnumber",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "categoryId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "secondFactor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "individualPart",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "noStartnumber",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchCategory",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchAllPhotos",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "minTime",
    "type": "NaiveDatetime",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "maxTime",
    "type": "NaiveDatetime",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sgId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "banner",
  "args": null,
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v1/*: any*/)
],
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "afterShotDate",
    "variableName": "minTime"
  },
  {
    "kind": "Variable",
    "name": "beforeShotDate",
    "variableName": "maxTime"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "media",
  "storageKey": null,
  "args": null,
  "concreteType": "ExtendedMediaConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "mediaInfo",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "shotDateMax",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "shotDateMin",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "mediaList",
      "storageKey": null,
      "args": (v7/*: any*/),
      "concreteType": "MediaConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Media",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "shotDate",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "variants",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaFile",
                  "plural": true,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "url",
                      "args": null,
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ]
                },
                (v4/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedHandle",
      "alias": null,
      "name": "mediaList",
      "args": (v7/*: any*/),
      "handle": "connection",
      "key": "MediaCollectionList_mediaList",
      "filters": [
        "afterShotDate",
        "beforeShotDate"
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EventCategorySearchPageRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EventCategorySearchPage_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EventCategorySearchPageRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "eventId"
              },
              {
                "kind": "Variable",
                "name": "language",
                "variableName": "language"
              }
            ],
            "concreteType": "Event",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "gps",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hostResultUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "searchAllPhotos",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "secondFactorType",
                "storageKey": null,
                "args": null,
                "concreteType": "SecondFactorType",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "searchByFace",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "searchDual",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "smartSearch",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "state",
                "args": null,
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "beginsAt",
                "args": null,
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hostHomepageName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hostHomepageUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "location",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "predecessorEvent",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": (v6/*: any*/)
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "secondFactorEventSalt",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "individualPart",
                    "variableName": "individualPart"
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "warnText",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "faceWebcamOnly",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaCollections",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaCollection",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "products",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaCollection",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediaCollection",
                    "plural": false,
                    "selections": (v6/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "price",
                    "args": null,
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "voucherCampaign",
                "storageKey": null,
                "args": null,
                "concreteType": "VoucherCampaign",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shortText",
                    "args": null,
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "fetchAllPhotos",
                "selections": [
                  (v8/*: any*/)
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "fetchCategory",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaCollection",
                    "storageKey": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "categoryId"
                      }
                    ],
                    "concreteType": "MediaCollection",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": false,
                "condition": "noStartnumber",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "participant",
                    "storageKey": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "secondFactor",
                        "variableName": "secondFactor"
                      },
                      {
                        "kind": "Variable",
                        "name": "startnumber",
                        "variableName": "startnumber"
                      }
                    ],
                    "concreteType": "Participant",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "media",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ExtendedMediaConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "mediaInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "count",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "startnumber",
                        "args": null,
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "EventCategorySearchPageRefetchQuery",
    "id": null,
    "text": "query EventCategorySearchPageRefetchQuery(\n  $eventId: ID!\n  $language: String\n  $startnumber: ID!\n  $categoryId: ID!\n  $count: Int!\n  $cursor: String\n  $secondFactor: String\n  $individualPart: String\n  $noStartnumber: Boolean\n  $fetchCategory: Boolean\n  $fetchAllPhotos: Boolean\n  $minTime: NaiveDatetime\n  $maxTime: NaiveDatetime\n) {\n  viewer {\n    ...EventCategorySearchPage_viewer\n    id\n  }\n}\n\nfragment EventCategorySearchPage_viewer on Viewer {\n  event(id: $eventId, language: $language) {\n    id\n    sgId\n    gps\n    hostResultUrl\n    media @include(if: $fetchAllPhotos) {\n      mediaInfo {\n        shotDateMax\n        shotDateMin\n      }\n      ...MediaCollectionList_mediaCollectionMedia_2HnSXF\n    }\n    mediaCollection(id: $categoryId) @include(if: $fetchCategory) {\n      id\n      media {\n        mediaInfo {\n          shotDateMax\n          shotDateMin\n        }\n        ...MediaCollectionList_mediaCollectionMedia_2HnSXF\n      }\n    }\n    participant(startnumber: $startnumber, secondFactor: $secondFactor) @skip(if: $noStartnumber) {\n      media {\n        mediaInfo {\n          count\n        }\n      }\n      startnumber\n      id\n    }\n    searchAllPhotos\n    secondFactorType {\n      type\n      id\n    }\n    searchByFace\n    searchDual\n    smartSearch\n    state\n    ...EventOnlineView_onlineEvent\n    ...MediaCollectionList_offer\n  }\n}\n\nfragment EventInfoCard_eventInfo on Event {\n  id\n  sgId\n  beginsAt\n  banner\n  hostHomepageName\n  hostHomepageUrl\n  location\n  name\n  predecessorEvent {\n    name\n    id\n  }\n}\n\nfragment EventOnlineView_onlineEvent on Event {\n  id\n  sgId\n  hostResultUrl\n  name\n  ...EventInfoCard_eventInfo\n  ...StartNumberSearch_info\n  ...ExtendedSearch_event\n}\n\nfragment ExtendedSearchCategorySearchTab_categories on Event {\n  mediaCollections {\n    id\n    name\n  }\n  searchAllPhotos\n}\n\nfragment ExtendedSearchDualSearchTab_event on Event {\n  id\n  sgId\n  searchByFace\n  ...StartNumberSearch_info\n}\n\nfragment ExtendedSearch_event on Event {\n  id\n  sgId\n  searchByFace\n  ...ExtendedSearchCategorySearchTab_categories\n  ...ExtendedSearchDualSearchTab_event\n}\n\nfragment MediaCollectionList_mediaCollectionMedia_2HnSXF on ExtendedMediaConnection {\n  mediaList(first: $count, after: $cursor, afterShotDate: $minTime, beforeShotDate: $maxTime) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    ...MediaList_media\n  }\n}\n\nfragment MediaCollectionList_offer on Event {\n  ...MediaList_offer\n}\n\nfragment MediaListItem_item on Media {\n  id\n  sgId\n  name\n  shotDate\n  variants {\n    name\n    url\n    id\n  }\n}\n\nfragment MediaList_media on MediaConnection {\n  edges {\n    node {\n      id\n      sgId\n      shotDate\n      variants {\n        name\n        url\n        id\n      }\n      ...MediaListItem_item\n    }\n  }\n}\n\nfragment MediaList_offer on Event {\n  products {\n    id\n    mediaCollection {\n      name\n      id\n    }\n    price\n    type\n  }\n  voucherCampaign {\n    banner\n    name\n    shortText\n    id\n  }\n}\n\nfragment StartNumberSearch_info on Event {\n  id\n  gps\n  searchByFace\n  searchDual\n  secondFactorEventSalt(individualPart: $individualPart)\n  secondFactorType {\n    type\n    id\n  }\n  sgId\n  hostResultUrl\n  warnText\n  faceWebcamOnly\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6993e33e3324df140cba08eaad7e6937';

module.exports = node;
